import { AssertNonNull } from '../../../utils/assert';

export const getSetIdFromUrl = (url: string): string => {
  const regex = new RegExp('/webinar/([^/]+)');
  const matches = regex.exec(url);
  const slug = (matches && matches[1]) || '';
  const id = AssertNonNull(slug.split('-').pop());
  return id;
};
